export default "/images/arm_business_bank.png?8ba6f03e39c3deff00445c33b5e8a72c";